<template>
    <div class="noData">
        <img src="@/assets/home/nodata.png" alt="">
        <div class="title">{{ title || $t("home.nodata") }}</div>
        <div class="desc">{{ desc}}</div>
    </div>
</template>

<script>
export default {
    name: "NoData",
    props: {
        title: {
            type: String,
            default: "",
        },
        desc: {
            type: String,
            default: "",
        },
    },
    data() {
        return {};
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.noData {
    width: 100%;
    margin: 20px 0;
    text-align: center;
    img {
        max-width: 70%;
        height: auto;
    }
    .title {
        margin-top: 16px;
        font-size: 16px;
        color: #5c616a;
    }
    .desc {
        margin-top: 6px;
        font-size: 12px;
        color: #5c616a;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/noData.vue